import { createModelId } from "@core/foundation/model";
import type { z } from "@core/zod";

import { ID_PREFIX } from "./id-prefix.ts";

const { generateId: generateTaxonomyId, idSchema: TaxonomyIdSchema } =
  createModelId({ idPrefix: ID_PREFIX.TAXONOMY });

export { TaxonomyIdSchema, generateTaxonomyId };

export type TaxonomyId = z.infer<typeof TaxonomyIdSchema>;
